<template>
  <li class="article-list-item padded-container">
    <div class="header">
      <div class="row">
        <div class="article-ref small-6 column">
          <strong>{{articleName}}</strong><br>
          <em>{{$t('order.label.item.reference')}}&nbsp;{{articleRef}}</em>
        </div>
        <div class="small-6 column">
          <div class="clearfix">
            <div class="float-right"><status-chips v-bind:status="articleStatus"></status-chips></div>
            <div class="delivery-flags float-right">
              <ui-icon icon="warning" class="notif-warning-color" v-if="deliveryDateHasChanged"></ui-icon>
              <ui-icon icon="info" class="notif-info-color" v-if="deliveryDateIsDifferent"></ui-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="row lateral-sub-padding">
        <div class="small-5 medium-3 large-2 column">{{$t('order.label.item.ordered-qty')}}</div>
        <div class="small-7 medium-9 large-10 column"><strong>{{articleOrderedQty}}</strong></div>
      </div>
      <div class="row delivery-date lateral-sub-padding">
        <div class="small-5 medium-3 large-2 column">{{$t('order.label.estimed-delivery-date')}}</div>
        <div class="small-7 medium-9 large-10 column"  v-bind:class="{ 'notif-warning-color': deliveryDateHasChanged, 'notif-info-color': deliveryDateIsDifferent }">
          <div>
            <strong><span>le&nbsp;{{formatDate(deliveryDate)}}</span></strong>
          </div>
          <div class="delivery-messages" v-if="deliveryDateIsDifferent || deliveryDateHasChanged">
            <div class="notif-warning-color" v-if="deliveryDateHasChanged">{{$t('order.label.estimed-delivery-date-has-changed')}}</div>
            <div class="notif-info-color" v-if="deliveryDateIsDifferent">{{$t('order.label.estimed-delivery-date-is-different')}}</div>
          </div>
        </div>
      </div>
      <div class="row lateral-sub-padding">
        <div class="small-5 medium-3 large-2 column">{{$t('order.label.item.comment')}}</div>
        <div class="small-7 medium-9 large-10 column"><strong>{{articleNote}}</strong></div>
      </div>
      <div class="lateral-sub-padding">
        <tracking-list v-if="articleShippedQty > 0"
           :tracking-items="deliveryTracking"
           :article-ordered-qty="articleOrderedQty"
           :article-shipped-qty="articleShippedQty">
        </tracking-list>
      </div>

      <div class="row lateral-sub-padding" v-if="articleStatus == 'in-progress' && !hasDeliveryTracking">
        <div class="small-5 medium-3 large-2 column">{{$t('order.label.item.tracking.shipped-qty')}}</div>
        <div class="small-7 medium-9 large-10 column"><strong>{{articleShippedQty}}</strong></div>
      </div>
    </div>
  </li>
</template>

<script>
  import moment from 'moment'
  import StatusChips from 'components/StatusChips'
  import TrackingList from 'components/TrackingList'

  export default {
    name: 'article-list-item',
    props: [
      'article-ref',
      'article-name',
      'article-status',
      'article-ordered-qty',
      'article-shipped-qty',
      'article-note',
      'delivery-tracking',
      'delivery-date',
      'delivery-date-is-different',
      'delivery-date-has-changed'
    ],
    components: {
      'status-chips': StatusChips,
      'tracking-list': TrackingList
    },
    computed: {
      getDeliveryTracking: function () {
        return this.deliveryTracking || []
      },
      hasDeliveryTracking: function () {
        return this.getDeliveryTracking.length
      }
    },
    methods: {
      formatDate: function (date) {
        return date ? moment(date).format('DD.MM.YYYY') : null
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';
  @import '~foundation';

  li.article-list-item {
    .notif-info-color {
      color: $warning;
    }

    .notif-warning-color {
      color: $danger;
    }

    .notif-info-color.notif-warning-color {
      color: $danger;
    }

    .header {
      border-top: 1px solid $grey-50;

      /* Medium and up */
      @include breakpoint(medium) {
        border-left: 1px solid $grey-50;
        border-right: 1px solid $grey-50;
      }
      background-color: $grey-10;
      padding: 7px 0;

      .article-ref {
        strong {
          font-size: 14px;
          font-weight: normal;
          line-height: 1.5;
        }
        em {
          font-style:normal;
          font-size: 12px;
        }
      }

      .status-chips {
        margin-top: 7px;
      }

      .delivery-flags {
        margin-right: 2px;
        margin-top: 4px;

        .ui-icon {
          font-size: 26px;
          margin-right: 2px;
        }
      }
    }

    .content {
      padding-top: 15px;
      padding-bottom: 15px;
      line-height: 1.5;

      /* Medium and up */
      @include breakpoint(medium) {
        border-left: 1px solid $grey-50;
        border-right: 1px solid $grey-50;
      }

      .delivery-messages {
        font-size: 9px;
      }
    }

    &:last-of-type {
      .content {
        border-bottom: 1px solid $grey-50;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ArticleListItem.vue?3ec0a113